import React from "react";

function Sports() {
  return (
    <>
      <div className="bx">
        Rocket League
        <br />
        3.9/5
      </div>
      <div className="bx">
        NBA 2K21 <br />
        4.0/5
      </div>

      <div className="bx">
        Mutant Football League <br />
        4/5
      </div>
    </>
  );
}

export default Sports;
